let url = "https://beta.csa360.app/api/v1/";
let host = window.location.hostname;

if(host.includes("localhost") || host.includes("csa.local")){
	if(host.includes("localhost")){
    url = "http://localhost/csa_360/api/v1/";
  }
  else {
      url = "https://csa.local/api/v1/"; //Tere
  }
}

if(host.includes("login")){
    url = "https://login.csa360.app/api/v1/";
}
if(host.includes("alpha")){
    url = "https://alpha.csa360.app/api/v1/";
}

export default {
    //Users
    API_URL: url,
    LOGIN_API: url + 'users?action=login',
    GET_USERS_API: url + 'users?action=get_users',
    ADD_USER_API: url + 'users?action=add',
    GET_USER_API: url + 'users?action=get_user',
    EDIT_USER_API: url + 'users?action=update',
    DELETE_USER_API: url + 'users?action=delete',
    LOCAL_LOGIN_API:  url + 'users?action=login',
    CRYPTO_SECRET: 'C$a36O@pp',
    API_LITMOS_URL: url + '/litmos_proxy.php?',
    API_GET_LITMOS_USER: url + 'users?action=get_litmos_user',
    AWS_KEY_ACCESS_ID: 'AKIAJL6Q3YRWPROZ23ZA',
    AWS_SECRET_ACCESS_KEY: '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',
    GET_USERS_ON_DUTY:  url + 'users?action=get_on_duty',

    //Custom Forms
    API_UPLOAD_FORM_TO_S3:  url + 'forms?action=upload_forms_to_s3',
    CSA_FORMS_S3_PATH: 'https://s3.us-east-2.amazonaws.com/csa360-forms/',
    API_GET_ALL_FORMS_BY_LICENSE: url + 'forms?action=get_forms_by_license',
    API_SAVE_CUSTOM_FORM: url + 'forms?action=save_custom_form',
    API_DELETE_FORM: url + 'forms?action=delete',

    //Form Data
    API_GET_FORM_DATA_BY_TYPE: url + 'formdata?action=get_form_data_by_type',
    API_SAVE_FORM_DATA: url + 'formdata?action=save_form_data',
    API_GET_DROPDOWN_DATA_FOR_ADD_FORM: url + 'formdata?action=get_dropdowndata_in_add_form',
    API_UPDATE_DROPDOWN_DATA : url + 'formdata?action=update_form_data',
    API_DELETE_DROPDOWN_DATA : url + 'formdata?action=delete_form_data',
    API_UPDATE_CUSTOM_NAME : url + 'formdata?action=update_custom_name',

    //Uploading
    API_UPLOAD_USERS : url + 'users?action=add_users',
    API_UPLOAD_USERS_FROM_CIRRUS : url + 'users?action=add_users_from_cirrus_db',
    UPDATE_USER_STATUS_API: url + 'users?action=update_user_status',

    CSA_LOGO_S3_PATH: 'https://s3.us-east-2.amazonaws.com/csa360-site-logos/',
    GET_LOGO_BY_TYPE_API: url + 'logos?action=get_logo_by_type',
    UPLOAD_LOGO_API: url + 'logos?action=upload_site_logo',
    DELETE_LOGO_API: url + 'logos?action=delete',

    CSA_REPORTS_S3_PATH: 'https://s3.us-east-2.amazonaws.com/csa360-reports/',

    //Reports Forms
    FETCH_REPORTS_API: url + 'reports?action=get_reports',
    UPLOAD_REPORT_API: url + 'reports?action=upload', //add report and edit report (if file is included)
    DELETE_REPORT_API: url + 'reports?action=delete',
    GET_REPORTS_BY_USER_API: url + 'reports?action=get_reports_by_user',
    GET_REPORTS_BY_LICENSE_API: url + 'reports?action=get_reports_by_license',
    EDIT_REPORT_API: url + 'reports?action=edit', //edit report by name only

    //Submitted Forms
    API_SUBMIT_CUSTOM_FORM: url + 'forms?action=submit_custom_form',
    API_UPDATE_SUBMITTED_FORM: url + 'forms?action=update_submitted_form',
    API_GET_SUBMITTED_FORMS: url + 'forms?action=get_submitted_forms',
    API_GET_SUBMITTED_FORM_BY_ID: url + 'forms?action=get_submitted_form',
    API_GET_SUBMITTED_FORM_BY_LICENSE: url + 'forms?action=get_submitted_forms_by_license',
    API_DELETE_SUBMITTED_FORM: url + 'forms?action=delete_submitted_form',

    // Activity Logs
    GET_ACTIVITY_LOGS_API: url + 'activitylogs?action=get_logs_by_license',
    GET_ACTIVITY_LOGS_DATE_RANGE_API: url + 'activitylogs?action=get_logs_by_date_range',
    GET_ACTIVITY_LOGS_FACILITIES_API: url + 'activitylogs?action=get_facilities_by_license',

    //Email Service
    SEND_EMAIL_API: url + 'emails?action=send',
    API_EMAIL_USER_CREDENTIALS: url + 'emails?action=email_user_credentials',
    EMAIL_INCIDENT_REPORT: url + 'emails?action=email_incident_report',

    //Clients
    CLIENT_API: url + 'clients',
    GET_ALL_CLIENTS_API: url + 'clients?action=get_all',
    GET_CLIENT_BY_SUB_API: url + 'clients?action=get_client_by_sub',
    ADD_CLIENT_API: url + 'clients?action=new_client',
    UPDATE_CLIENT_API: url + 'clients?action=update_client',
    UPDATE_CLIENT_STATUS_API: url + 'clients?action=update_status',

    //Incidents
    ADD_INCIDENTS_API: url + 'incidents?action=add',
    UPDATE_INCIDENTS_API: url + 'incidents?action=update',
    GET_INCIDENTS_API: url + 'incidents?action=get',
    GET_ALL_INCIDENTS_API: url + 'incidents?action=get_all',
    GET_ALL_REPEAT_OFFENDER_API: url + 'incidents?action=get_repeat_offender',
    DELETE_INCIDENTS_API: url + 'incidents?action=delete',
    MERGE_INCIDENTS_API: url + 'incidents?action=merge',
    LINK_INCIDENTS_API: url + 'incidents?action=link',
    GET_INCIDENT_HISTORY_API: url + 'incidents?action=get_logs',

    //Assignments
    SET_ON_DUTY_STATUS: url + 'assignments?action=set_on_duty_status',
    GET_ALL_BY_LICENSE_API: url + 'assignments?action=get_all_by_license',
    GET_ALL_BY_PERSONNEL_ID_API: url + 'assignments?action=get_all_by_personnel_id',

    //Tours API
    GET_FACILITY_LOCATIONS: url + 'tours?action=get_facility_locations',
    GET_FACILITY_LOCATION: url + 'tours?action=get_location',
    SAVE_LOCATION_SCHEDULES: url + 'tours?action=save_location_schedules',
    SAVE_LOCATION_POST_ORDERS: url + 'tours?action=save_post_orders',


    //DISPATCHES
    GET_ALL_DISPATCHES_API: url + 'dispatches?action=get_all_by_license',
    SAVE_DISPATCH_API: url + 'dispatches?action=add',
    EDIT_DISPATCH_API: url + 'dispatches?action=update',
    DELETE_DISPATCH_API: url + 'dispatches?action=delete',
    GET_DISPATCH_BY_ID_API: url + 'dispatches?action=get',
    LINK_DISPATCH_API: url + 'dispatches?action=link',
    GET_LAST_DISPATCH_ID_API: url + 'dispatches?action=get_last_dispatch_id',
    UPDATED_DISPATCH_STATUS_API: url + 'dispatches?action=update_dispatch_status',

    //Event widget
    GET_EVENT_INCIDENTS_SUMMARY_API: url + 'widgets?action=get_event_summary_data',

};
